import {
  FEATURE_FLAG_HEADER_PREFIX,
  FEATURE_FLAG_QUERY_PREFIX,
} from "./constants";

async function checkFeatureFlagHeader(
  flagName: string,
): Promise<string | null> {
  const { headers } = await import("next/headers");
  const headersList = await headers();
  const headerName = `${FEATURE_FLAG_HEADER_PREFIX}${flagName}`;
  const headerValue = headersList.get(headerName);

  return headerValue;
}

async function checkFeatureFlagQueryParam(
  flagName: string,
): Promise<string | null> {
  const urlParams = new URLSearchParams(window.location.search);
  const queryParam = urlParams.get(`${FEATURE_FLAG_QUERY_PREFIX}${flagName}`);
  return queryParam;
}

export default function checkFeatureFlagParam(
  flagName: string,
): Promise<string | null> {
  if (typeof window === "undefined") {
    return checkFeatureFlagHeader(flagName);
  } else {
    return checkFeatureFlagQueryParam(flagName);
  }
}
